(() => {
    console.log('not loading at all');
  const showPage = () => {
    document.body.classList.add('page-is-loaded');
  };

  const fadeImages = () => {
    const images = document.querySelectorAll('img:not([data-no-fade])');

    images.forEach((image) => {
      if (image.complete) {
        image.classList.add('image-is-loaded');
      } else {
        image.addEventListener(
          'load',
          () => {
            image.classList.add('image-is-loaded');
          },
          { once: true }
        );

        image.addEventListener(
          'error',
          () => {
            image.classList.add('image-is-loaded');
          },
          { once: true }
        );
      }
    });
  };

  if (document.readyState === 'loading') {
    console.log('if');
    document.addEventListener('DOMContentLoaded', () => {
        console.log('loaded');
      showPage();
      //fadeImages();
    });
  } else {
    console.log('else');
    showPage();
    //fadeImages();
  }
})();